import type { GetResponse, News } from 'types';
import { _has_t_back } from './translateEngine';

export const NEWS_CATEGORY_ID = 3;

export type NewsSortOrder = 'desc' | 'asc';
export type NewsCategoryFilter = 'all' | 'news';

type NewsListParams = {
  limit?: number,
  offset?: number,
  search?: string,
  sortOrder?: NewsSortOrder,
  categoryFilter?: NewsCategoryFilter,
};

const getNewsTitle = (item: News): string => {
  const translated = (item.translations as {
    ru?: { title_t?: string },
  } | undefined)?.ru?.title_t;

  return translated || item.title || '';
};

const getPubdateTimestamp = (value: string): number => {
  const timestamp = Date.parse(value);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const isNewsCategoryItem = (item: News): boolean => (
  item.category?.id === NEWS_CATEGORY_ID
);

export const parseNewsListResponse = (
  data: GetResponse<News[]> | News[] | null | undefined,
  params: NewsListParams = {},
): GetResponse<News[]> => {
  const {
    limit,
    offset = 0,
    search = '',
    sortOrder = 'desc',
    categoryFilter = 'all',
  } = params;

  let items: News[] = [];

  if (Array.isArray(data)) {
    items = data;
  } else if (data?.results) {
    items = data.results;
  }

  items = items.filter((item) => _has_t_back(item));

  if (categoryFilter === 'news') {
    items = items.filter(isNewsCategoryItem);
  }

  const query = search.trim().toLowerCase();
  if (query) {
    items = items.filter((item) => getNewsTitle(item).toLowerCase().includes(query));
  }

  items.sort((left, right) => {
    const delta = getPubdateTimestamp(right.pubdate) - getPubdateTimestamp(left.pubdate);
    return sortOrder === 'desc' ? delta : -delta;
  });

  const count = items.length;

  if (limit != null) {
    items = items.slice(offset, offset + limit);
  }

  return {
    count,
    results: items,
  };
};

export const NEWS_SORT_OPTIONS: Array<{ id: NewsSortOrder, label: string }> = [
  { id: 'desc', label: 'Дате публикации (сначала новые)' },
  { id: 'asc', label: 'Дате публикации (сначала старые)' },
];
